// Generated file, changes will eventually be overwritten!
import { Talent } from './types';

const talents = {
  ABSOLUTE_CORRUPTION_TALENT: {
    id: 196103,
    name: 'Absolute Corruption',
    icon: 'ability_bossmannoroth_empoweredmannorothsgaze',
    maxRanks: 1,
    entryIds: [91575],
    definitionIds: [{ id: 96577, specId: 265 }],
  },
  ABYSS_WALKER_TALENT: {
    id: 389609,
    name: 'Abyss Walker',
    icon: 'achievement_explore_argus',
    maxRanks: 1,
    entryIds: [91465],
    definitionIds: [{ id: 96467, specId: 266 }],
  },
  ACCRUED_VITALITY_TALENT: {
    id: 386613,
    name: 'Accrued Vitality',
    icon: 'spell_shadow_lifedrain',
    maxRanks: 2,
    entryIds: [91464],
    definitionIds: [{ id: 96466, specId: 266 }],
  },
  AGONIZING_CORRUPTION_TALENT: {
    id: 386922,
    name: 'Agonizing Corruption',
    icon: 'spell_warlock_darkregeneration',
    maxRanks: 2,
    entryIds: [91559],
    definitionIds: [{ id: 96561, specId: 265 }],
  },
  AMPLIFY_CURSE_TALENT: {
    id: 328774,
    name: 'Amplify Curse',
    icon: 'spell_shadow_contagion',
    maxRanks: 1,
    entryIds: [91442],
    definitionIds: [{ id: 96444, specId: 266 }],
  },
  ANNIHILAN_TRAINING_TALENT: {
    id: 386174,
    name: 'Annihilan Training',
    icon: 'ability_bossmannoroth_glaivethrust',
    maxRanks: 1,
    entryIds: [91542],
    definitionIds: [{ id: 96544, specId: 266 }],
  },
  ANTORAN_ARMAMENTS_TALENT: {
    id: 387494,
    name: 'Antoran Armaments',
    icon: 'inv_axe_1h_felfireraid_d_01',
    maxRanks: 1,
    entryIds: [91526],
    definitionIds: [{ id: 96528, specId: 266 }],
  },
  ASHEN_REMAINS_TALENT: {
    id: 387252,
    name: 'Ashen Remains',
    icon: 'inv_enchanting_dust',
    maxRanks: 2,
    entryIds: [91482],
    definitionIds: [{ id: 96484, specId: 267 }],
  },
  AVATAR_OF_DESTRUCTION_TALENT: {
    id: 387159,
    name: 'Avatar of Destruction',
    icon: 'inv_infernalmountblue',
    maxRanks: 1,
    entryIds: [91476],
    definitionIds: [{ id: 96478, specId: 267 }],
  },
  BACKDRAFT_TALENT: {
    id: 196406,
    name: 'Backdraft',
    icon: 'ability_warlock_backdraft',
    maxRanks: 1,
    entryIds: [91589],
    definitionIds: [{ id: 96591, specId: 267 }],
  },
  BACKLASH_TALENT: {
    id: 387384,
    name: 'Backlash',
    icon: 'spell_fire_playingwithfire',
    maxRanks: 1,
    entryIds: [91500],
    definitionIds: [{ id: 96502, specId: 267 }],
  },
  BANISH_TALENT: {
    id: 710,
    name: 'Banish',
    icon: 'spell_shadow_cripple',
    maxRanks: 1,
    entryIds: [91454],
    definitionIds: [{ id: 96456, specId: 266 }],
    manaCost: 3750,
  },
  BILESCOURGE_BOMBERS_TALENT: {
    id: 267211,
    name: 'Bilescourge Bombers',
    icon: 'ability_hunter_pet_bat',
    maxRanks: 1,
    entryIds: [91541],
    definitionIds: [{ id: 96543, specId: 266 }],
  },
  BURNING_RUSH_TALENT: {
    id: 111400,
    name: 'Burning Rush',
    icon: 'ability_deathwing_sealarmorbreachtga',
    maxRanks: 1,
    entryIds: [91460],
    definitionIds: [{ id: 96462, specId: 266 }],
  },
  BURN_TO_ASHES_TALENT: {
    id: 387153,
    name: 'Burn to Ashes',
    icon: 'ability_racial_foregedinflames',
    maxRanks: 2,
    entryIds: [91477],
    definitionIds: [{ id: 96479, specId: 267 }],
  },
  CALL_DREADSTALKERS_TALENT: {
    id: 104316,
    name: 'Call Dreadstalkers',
    icon: 'spell_warlock_calldreadstalkers',
    maxRanks: 1,
    entryIds: [91543],
    definitionIds: [{ id: 96545, specId: 266 }],
    soulShardsCost: 2,
  },
  CARNIVOROUS_STALKERS_TALENT: {
    id: 386194,
    name: 'Carnivorous Stalkers',
    icon: 'warlock_pvp_callfelhunter',
    maxRanks: 1,
    entryIds: [91536],
    definitionIds: [{ id: 96538, specId: 266 }],
  },
  CATACLYSM_TALENT: {
    id: 152108,
    name: 'Cataclysm',
    icon: 'achievement_zone_cataclysm',
    maxRanks: 1,
    entryIds: [91487],
    definitionIds: [{ id: 96489, specId: 267 }],
    manaCost: 2500,
  },
  CAVITATION_TALENT: {
    id: 416154,
    name: 'Cavitation',
    icon: 'warrior_talent_icon_mastercleaver',
    maxRanks: 2,
    entryIds: [91527],
    definitionIds: [{ id: 96529, specId: 266 }],
  },
  CHANNEL_DEMONFIRE_TALENT: {
    id: 196447,
    name: 'Channel Demonfire',
    icon: 'spell_fire_ragnaros_lavaboltgreen',
    maxRanks: 1,
    entryIds: [91586],
    definitionIds: [{ id: 96588, specId: 267 }],
    manaCost: 3750,
  },
  CHAOSBRINGER_TALENT: {
    id: 422057,
    name: 'Chaosbringer',
    icon: 'inv_shadowflames_wave',
    maxRanks: 2,
    entryIds: [91480],
    definitionIds: [{ id: 96482, specId: 267 }],
  },
  CHAOS_BOLT_TALENT: {
    id: 116858,
    name: 'Chaos Bolt',
    icon: 'ability_warlock_chaosbolt',
    maxRanks: 1,
    entryIds: [91591],
    definitionIds: [{ id: 96593, specId: 267 }],
    soulShardsCost: 2,
  },
  CHAOS_INCARNATE_TALENT: {
    id: 387275,
    name: 'Chaos Incarnate',
    icon: 'spell_fire_felflamering',
    maxRanks: 1,
    entryIds: [91479],
    definitionIds: [{ id: 96481, specId: 267 }],
  },
  CONFLAGRATE_TALENT: {
    id: 17962,
    name: 'Conflagrate',
    icon: 'spell_fire_fireball',
    maxRanks: 1,
    entryIds: [91590],
    definitionIds: [{ id: 96592, specId: 267 }],
    manaCost: 2500,
  },
  CONFLAGRATION_OF_CHAOS_TALENT: {
    id: 387108,
    name: 'Conflagration of Chaos',
    icon: 'spell_shadow_scourgebuild',
    maxRanks: 2,
    entryIds: [91583],
    definitionIds: [{ id: 96585, specId: 267 }],
  },
  CRASHING_CHAOS_TALENT: {
    id: 417234,
    name: 'Crashing Chaos',
    icon: 'inv_infernalmount',
    maxRanks: 2,
    entryIds: [91473],
    definitionIds: [{ id: 96475, specId: 267 }],
  },
  CREEPING_DEATH_TALENT: {
    id: 264000,
    name: 'Creeping Death',
    icon: 'ability_creature_cursed_03',
    maxRanks: 1,
    entryIds: [91580],
    definitionIds: [{ id: 96582, specId: 265 }],
  },
  CRY_HAVOC_TALENT: {
    id: 387522,
    name: 'Cry Havoc',
    icon: 'inv_offhand_1h_artifactskulloferedar_d_05',
    maxRanks: 1,
    entryIds: [91497],
    definitionIds: [{ id: 96499, specId: 267 }],
  },
  CURSES_OF_ENFEEBLEMENT_TALENT: {
    id: 386105,
    name: 'Curses of Enfeeblement',
    icon: 'ability_creature_cursed_02',
    maxRanks: 1,
    entryIds: [91462],
    definitionIds: [{ id: 96464, specId: 266 }],
  },
  DARKFURY_TALENT: {
    id: 264874,
    name: 'Darkfury',
    icon: 'ability_warlock_shadowfurytga',
    maxRanks: 1,
    entryIds: [91451],
    definitionIds: [{ id: 96453, specId: 266 }],
  },
  DARK_ACCORD_TALENT: {
    id: 386659,
    name: 'Dark Accord',
    icon: 'ability_warlock_improveddemonictactics',
    maxRanks: 1,
    entryIds: [91467],
    definitionIds: [{ id: 96469, specId: 266 }],
  },
  DARK_HARVEST_TALENT: {
    id: 387016,
    name: 'Dark Harvest',
    icon: 'spell_misc_zandalari_council_soulswap',
    maxRanks: 1,
    entryIds: [91579],
    definitionIds: [{ id: 96581, specId: 265 }],
  },
  DARK_PACT_TALENT: {
    id: 108416,
    name: 'Dark Pact',
    icon: 'spell_shadow_deathpact',
    maxRanks: 1,
    entryIds: [91444],
    definitionIds: [{ id: 96446, specId: 266 }],
  },
  DARK_VIRTUOSITY_TALENT: {
    id: 405327,
    name: 'Dark Virtuosity',
    icon: 'inv_elemental_primal_shadow',
    maxRanks: 2,
    entryIds: [91564],
    definitionIds: [{ id: 96566, specId: 265 }],
  },
  DECIMATION_TALENT: {
    id: 387176,
    name: 'Decimation',
    icon: 'spell_fire_firebolt',
    maxRanks: 1,
    entryIds: [91491],
    definitionIds: [{ id: 96493, specId: 267 }],
  },
  DEMONIAC_TALENT: {
    id: 426115,
    name: 'Demoniac',
    icon: 'inv_demonbolt',
    maxRanks: 1,
    entryIds: [91544],
    definitionIds: [{ id: 96546, specId: 266 }],
  },
  DEMONIC_CALLING_TALENT: {
    id: 205145,
    name: 'Demonic Calling',
    icon: 'ability_warlock_impoweredimp',
    maxRanks: 1,
    entryIds: [91535],
    definitionIds: [{ id: 96537, specId: 266 }],
  },
  DEMONIC_CIRCLE_TALENT: {
    id: 268358,
    name: 'Demonic Circle',
    icon: 'spell_shadow_demoniccirclesummon',
    maxRanks: 1,
    entryIds: [91441],
    definitionIds: [{ id: 96443, specId: 266 }],
    manaCost: 5000,
  },
  DEMONIC_EMBRACE_TALENT: {
    id: 288843,
    name: 'Demonic Embrace',
    icon: 'spell_shadow_metamorphosis',
    maxRanks: 1,
    entryIds: [91438],
    definitionIds: [{ id: 96440, specId: 266 }],
  },
  DEMONIC_FORTITUDE_TALENT: {
    id: 386617,
    name: 'Demonic Fortitude',
    icon: 'spell_warlock_summonimpoutland',
    maxRanks: 1,
    entryIds: [91430],
    definitionIds: [{ id: 96432, specId: 266 }],
  },
  DEMONIC_GATEWAY_TALENT: {
    id: 111771,
    name: 'Demonic Gateway',
    icon: 'spell_warlock_demonicportal_green',
    maxRanks: 1,
    entryIds: [91466],
    definitionIds: [{ id: 96468, specId: 266 }],
    manaCost: 50000,
  },
  DEMONIC_INSPIRATION_TALENT: {
    id: 386858,
    name: 'Demonic Inspiration',
    icon: 'ability_warlock_demonicpower',
    maxRanks: 1,
    entryIds: [91436],
    definitionIds: [{ id: 96438, specId: 266 }],
  },
  DEMONIC_KNOWLEDGE_TALENT: {
    id: 386185,
    name: 'Demonic Knowledge',
    icon: 'ability_warlock_improveddemonictactics',
    maxRanks: 1,
    entryIds: [91546],
    definitionIds: [{ id: 96548, specId: 266 }],
  },
  DEMONIC_RESILIENCE_TALENT: {
    id: 389590,
    name: 'Demonic Resilience',
    icon: 'ability_warlock_avoidance',
    maxRanks: 2,
    entryIds: [91424],
    definitionIds: [{ id: 96426, specId: 266 }],
  },
  DEMONIC_STRENGTH_TALENT: {
    id: 267171,
    name: 'Demonic Strength',
    icon: 'ability_warlock_demonicempowerment',
    maxRanks: 1,
    entryIds: [91540],
    definitionIds: [{ id: 96542, specId: 266 }],
  },
  DEMON_SKIN_TALENT: {
    id: 219272,
    name: 'Demon Skin',
    icon: 'spell_shadow_ragingscream',
    maxRanks: 2,
    entryIds: [91463],
    definitionIds: [{ id: 96465, specId: 266 }],
  },
  DIABOLIC_EMBERS_TALENT: {
    id: 387173,
    name: 'Diabolic Embers',
    icon: 'inv_shoulder_robe_raidmage_j_01',
    maxRanks: 1,
    entryIds: [91481],
    definitionIds: [{ id: 96483, specId: 267 }],
  },
  DIMENSIONAL_RIFT_TALENT: {
    id: 387976,
    name: 'Dimensional Rift',
    icon: 'spell_warlock_demonicportal_purple',
    maxRanks: 1,
    entryIds: [91423],
    definitionIds: [{ id: 96425, specId: 267 }],
  },
  DOOM_BLOSSOM_TALENT: {
    id: 416621,
    name: 'Doom Blossom',
    icon: 'ability_xavius_corruptingnova',
    maxRanks: 1,
    entryIds: [91503],
    definitionIds: [{ id: 96505, specId: 265 }],
  },
  DOOM_TALENT: {
    id: 603,
    name: 'Doom',
    icon: 'spell_shadow_auraofdarkness',
    maxRanks: 1,
    entryIds: [91548],
    definitionIds: [{ id: 96550, specId: 266 }],
    manaCost: 2500,
  },
  DRAIN_SOUL_TALENT: {
    id: 388667,
    name: 'Drain Soul',
    icon: 'spell_shadow_haunting',
    maxRanks: 1,
    entryIds: [91566],
    definitionIds: [{ id: 96568, specId: 265 }],
  },
  DREADLASH_TALENT: {
    id: 264078,
    name: 'Dreadlash',
    icon: 'spell_shadow_summonvoidwalker',
    maxRanks: 1,
    entryIds: [91539],
    definitionIds: [{ id: 96541, specId: 266 }],
  },
  DREAD_CALLING_TALENT: {
    id: 387391,
    name: 'Dread Calling',
    icon: 'inv_felhound3_shadow_mount',
    maxRanks: 2,
    entryIds: [91517],
    definitionIds: [{ id: 96519, specId: 266 }],
  },
  DREAD_TOUCH_TALENT: {
    id: 389775,
    name: 'Dread Touch',
    icon: 'ability_priest_touchofdecay',
    maxRanks: 1,
    entryIds: [91420],
    definitionIds: [{ id: 96422, specId: 265 }],
  },
  ERADICATION_TALENT: {
    id: 196412,
    name: 'Eradication',
    icon: 'ability_warlock_eradication',
    maxRanks: 2,
    entryIds: [91501],
    definitionIds: [{ id: 96503, specId: 267 }],
  },
  EXPLOSIVE_POTENTIAL_TALENT: {
    id: 388827,
    name: 'Explosive Potential',
    icon: 'spell_fire_felflamering_red',
    maxRanks: 1,
    entryIds: [91581],
    definitionIds: [{ id: 96583, specId: 267 }],
  },
  FEL_AND_STEEL_TALENT: {
    id: 386200,
    name: 'Fel and Steel',
    icon: 'ability_warrior_bladestorm',
    maxRanks: 1,
    entryIds: [91534],
    definitionIds: [{ id: 96536, specId: 266 }],
  },
  FEL_ARMOR_TALENT: {
    id: 386124,
    name: 'Fel Armor',
    icon: 'spell_shadow_felarmour',
    maxRanks: 2,
    entryIds: [91461],
    definitionIds: [{ id: 96463, specId: 266 }],
  },
  FEL_DOMINATION_TALENT: {
    id: 333889,
    name: 'Fel Domination',
    icon: 'spell_shadow_felmending',
    maxRanks: 1,
    entryIds: [91439],
    definitionIds: [{ id: 96441, specId: 266 }],
  },
  FEL_INVOCATION_TALENT: {
    id: 428351,
    name: 'Fel Invocation',
    icon: 'ability_bossfelorcs_necromancer_orange',
    maxRanks: 1,
    entryIds: [117752],
    definitionIds: [{ id: 122764, specId: 266 }],
  },
  FEL_PACT_TALENT: {
    id: 386113,
    name: 'Fel Pact',
    icon: 'spell_shadow_impphaseshift',
    maxRanks: 2,
    entryIds: [91440],
    definitionIds: [{ id: 96442, specId: 266 }],
  },
  FEL_SUNDER_TALENT: {
    id: 387399,
    name: 'Fel Sunder',
    icon: 'ability_creature_felsunder',
    maxRanks: 1,
    entryIds: [91528],
    definitionIds: [{ id: 96530, specId: 266 }],
  },
  FEL_SYNERGY_TALENT: {
    id: 389367,
    name: 'Fel Synergy',
    icon: 'inv_sword_1h_felfireraid_d_01',
    maxRanks: 1,
    entryIds: [91425],
    definitionIds: [{ id: 96427, specId: 266 }],
  },
  FIENDISH_STRIDE_TALENT: {
    id: 386110,
    name: 'Fiendish Stride',
    icon: 'inv_misc_moosehoof_fel',
    maxRanks: 2,
    entryIds: [91459],
    definitionIds: [{ id: 96461, specId: 266 }],
  },
  FIRE_AND_BRIMSTONE_TALENT: {
    id: 196408,
    name: 'Fire and Brimstone',
    icon: 'ability_warlock_fireandbrimstone',
    maxRanks: 2,
    entryIds: [91499],
    definitionIds: [{ id: 96501, specId: 267 }],
  },
  FLASHPOINT_TALENT: {
    id: 387259,
    name: 'Flashpoint',
    icon: 'spell_fire_moltenblood',
    maxRanks: 2,
    entryIds: [91485],
    definitionIds: [{ id: 96487, specId: 267 }],
  },
  FOCUSED_MALIGNANCY_TALENT: {
    id: 399668,
    name: 'Focused Malignancy',
    icon: 'spell_shadow_fingerofdeath',
    maxRanks: 2,
    entryIds: [91563],
    definitionIds: [{ id: 96565, specId: 265 }],
  },
  FREQUENT_DONOR_TALENT: {
    id: 386686,
    name: 'Frequent Donor',
    icon: 'ability_ironmaidens_bloodritual',
    maxRanks: 1,
    entryIds: [91445],
    definitionIds: [{ id: 96447, specId: 266 }],
  },
  GRAND_WARLOCKS_DESIGN_TALENT: {
    id: 387084,
    name: "Grand Warlock's Design",
    icon: 'spell_warlock_demonicportal_purple',
    maxRanks: 1,
    entryIds: [91505, 91471, 91508],
    definitionIds: [
      { id: 96507, specId: 265 },
      { id: 96473, specId: 267 },
      { id: 96510, specId: 266 },
    ],
  },
  GRIMOIRE_FELGUARD_TALENT: {
    id: 111898,
    name: 'Grimoire: Felguard',
    icon: 'spell_shadow_summonfelguard',
    maxRanks: 1,
    entryIds: [91531],
    definitionIds: [{ id: 96533, specId: 266 }],
    soulShardsCost: 1,
  },
  GRIMOIRE_OF_SACRIFICE_TALENT: {
    id: 108503,
    name: 'Grimoire of Sacrifice',
    icon: 'warlock_grimoireofsacrifice',
    maxRanks: 1,
    entryIds: [91576, 91484],
    definitionIds: [
      { id: 96578, specId: 265 },
      { id: 96486, specId: 267 },
    ],
  },
  GRIMOIRE_OF_SYNERGY_TALENT: {
    id: 171975,
    name: 'Grimoire of Synergy',
    icon: 'warlock_grimoireofsacrifice',
    maxRanks: 2,
    entryIds: [91432],
    definitionIds: [{ id: 96434, specId: 266 }],
  },
  GRIM_FEAST_TALENT: {
    id: 386689,
    name: 'Grim Feast',
    icon: 'inv_flaming_splinter',
    maxRanks: 1,
    entryIds: [91434],
    definitionIds: [{ id: 96436, specId: 266 }],
  },
  GRIM_REACH_TALENT: {
    id: 389992,
    name: 'Grim Reach',
    icon: 'warlock_curse_shadow',
    maxRanks: 1,
    entryIds: [91419],
    definitionIds: [{ id: 96421, specId: 265 }],
  },
  GUILLOTINE_TALENT: {
    id: 386833,
    name: 'Guillotine',
    icon: 'inv_axe_2h_felfireraid_d_01',
    maxRanks: 1,
    entryIds: [115460],
    definitionIds: [{ id: 120472, specId: 266 }],
  },
  GULDANS_AMBITION_TALENT: {
    id: 387578,
    name: "Gul'dan's Ambition",
    icon: 'achievement_dungeon_outland_dungeonmaster',
    maxRanks: 1,
    entryIds: [91513],
    definitionIds: [{ id: 96515, specId: 266 }],
  },
  HAUNTED_SOUL_TALENT: {
    id: 387301,
    name: 'Haunted Soul',
    icon: 'spell_warlock_soulburn_haunt',
    maxRanks: 1,
    entryIds: [91506],
    definitionIds: [{ id: 96508, specId: 265 }],
  },
  HAUNT_TALENT: {
    id: 48181,
    name: 'Haunt',
    icon: 'ability_warlock_haunt',
    maxRanks: 1,
    entryIds: [91552],
    definitionIds: [{ id: 96554, specId: 265 }],
    manaCost: 5000,
  },
  HAVOC_TALENT: {
    id: 80240,
    name: 'Havoc',
    icon: 'ability_warlock_baneofhavoc',
    maxRanks: 1,
    entryIds: [91493],
    definitionIds: [{ id: 96495, specId: 267 }],
    manaCost: 5000,
  },
  HEAVY_HANDED_TALENT: {
    id: 416183,
    name: 'Heavy Handed',
    icon: 'ability_butcher_heavyhanded',
    maxRanks: 1,
    entryIds: [91532],
    definitionIds: [{ id: 96534, specId: 266 }],
  },
  HORRIFY_TALENT: {
    id: 56244,
    name: 'Horrify',
    icon: 'spell_nzinsanity_bloodthirst',
    maxRanks: 1,
    entryIds: [115459],
    definitionIds: [{ id: 120471, specId: 266 }],
  },
  HOWL_OF_TERROR_TALENT: {
    id: 5484,
    name: 'Howl of Terror',
    icon: 'ability_warlock_howlofterror',
    maxRanks: 1,
    entryIds: [91458],
    definitionIds: [{ id: 96460, specId: 266 }],
    manaCost: 4500,
  },
  ICHOR_OF_DEVILS_TALENT: {
    id: 386664,
    name: 'Ichor of Devils',
    icon: 'spell_yorsahj_bloodboil_greenoil',
    maxRanks: 1,
    entryIds: [91446],
    definitionIds: [{ id: 96448, specId: 266 }],
  },
  IMMUTABLE_HATRED_TALENT: {
    id: 405670,
    name: 'Immutable Hatred',
    icon: 'ability_creature_felfrenzy',
    maxRanks: 1,
    entryIds: [91523],
    definitionIds: [{ id: 96525, specId: 266 }],
  },
  IMPLOSION_TALENT: {
    id: 196277,
    name: 'Implosion',
    icon: 'inv_implosion',
    maxRanks: 1,
    entryIds: [91520],
    definitionIds: [{ id: 96522, specId: 266 }],
    manaCost: 5000,
  },
  IMPROVED_CONFLAGRATE_TALENT: {
    id: 231793,
    name: 'Improved Conflagrate',
    icon: 'spell_fire_fireball',
    maxRanks: 1,
    entryIds: [91587],
    definitionIds: [{ id: 96589, specId: 267 }],
  },
  IMPROVED_IMMOLATE_TALENT: {
    id: 387093,
    name: 'Improved Immolate',
    icon: 'spell_fire_immolation',
    maxRanks: 2,
    entryIds: [91490],
    definitionIds: [{ id: 96492, specId: 267 }],
  },
  IMP_ERATOR_TALENT: {
    id: 416230,
    name: 'Imp-erator',
    icon: 'spell_warlock_summonimpoutland',
    maxRanks: 1,
    entryIds: [91545],
    definitionIds: [{ id: 96547, specId: 266 }],
  },
  IMP_GANG_BOSS_TALENT: {
    id: 387445,
    name: 'Imp Gang Boss',
    icon: 'ability_warlock_empoweredimp',
    maxRanks: 2,
    entryIds: [91516],
    definitionIds: [{ id: 96518, specId: 266 }],
  },
  INEVITABLE_DEMISE_TALENT: {
    id: 334319,
    name: 'Inevitable Demise',
    icon: 'spell_warlock_harvestoflife',
    maxRanks: 2,
    entryIds: [91567],
    definitionIds: [{ id: 96569, specId: 265 }],
  },
  INFERNAL_BRAND_TALENT: {
    id: 387475,
    name: 'Infernal Brand',
    icon: 'warlock_pvp_burninglegion',
    maxRanks: 2,
    entryIds: [91470],
    definitionIds: [{ id: 96472, specId: 267 }],
  },
  INFERNAL_COMMAND_TALENT: {
    id: 387549,
    name: 'Infernal Command',
    icon: 'ability_bossdarkvindicator_auraofcontempt',
    maxRanks: 2,
    entryIds: [91524],
    definitionIds: [{ id: 96526, specId: 266 }],
  },
  INFERNO_TALENT: {
    id: 270545,
    name: 'Inferno',
    icon: 'spell_shadow_rainoffire',
    maxRanks: 1,
    entryIds: [91488],
    definitionIds: [{ id: 96490, specId: 267 }],
  },
  INNER_DEMONS_TALENT: {
    id: 267216,
    name: 'Inner Demons',
    icon: 'ability_warlock_eradication',
    maxRanks: 1,
    entryIds: [91547],
    definitionIds: [{ id: 96549, specId: 266 }],
  },
  INQUISITORS_GAZE_TALENT: {
    id: 386344,
    name: "Inquisitor's Gaze",
    icon: 'inv_pet_inquisitoreye',
    maxRanks: 1,
    entryIds: [91427],
    definitionIds: [{ id: 96450, specId: 266 }],
  },
  INTERNAL_COMBUSTION_TALENT: {
    id: 266134,
    name: 'Internal Combustion',
    icon: 'ability_mage_livingbomb',
    maxRanks: 1,
    entryIds: [91495],
    definitionIds: [{ id: 96497, specId: 267 }],
  },
  KAZAAKS_FINAL_CURSE_TALENT: {
    id: 387483,
    name: "Kazaak's Final Curse",
    icon: 'inv_feldreadravenmount',
    maxRanks: 2,
    entryIds: [91549],
    definitionIds: [{ id: 96551, specId: 266 }],
  },
  KINDLED_MALICE_TALENT: {
    id: 405330,
    name: 'Kindled Malice',
    icon: 'inv_artifact_powerofthedarkside',
    maxRanks: 2,
    entryIds: [91561],
    definitionIds: [{ id: 96563, specId: 265 }],
  },
  LIFEBLOOD_TALENT: {
    id: 386646,
    name: 'Lifeblood',
    icon: 'warlock__healthstone',
    maxRanks: 2,
    entryIds: [91449],
    definitionIds: [{ id: 96451, specId: 266 }],
  },
  MALEFIC_IMPACT_TALENT: {
    id: 416341,
    name: 'Malefic Impact',
    icon: 'ability_warlock_handofguldan',
    maxRanks: 1,
    entryIds: [91530],
    definitionIds: [{ id: 96532, specId: 266 }],
  },
  MALEFIC_RAPTURE_TALENT: {
    id: 324536,
    name: 'Malefic Rapture',
    icon: 'ability_warlock_everlastingaffliction',
    maxRanks: 1,
    entryIds: [91570],
    definitionIds: [{ id: 96572, specId: 265 }],
    soulShardsCost: 1,
  },
  MALEVOLENT_VISIONARY_TALENT: {
    id: 387273,
    name: 'Malevolent Visionary',
    icon: 'inv_archaeology_70_crystallineeyeofundravius',
    maxRanks: 2,
    entryIds: [91504],
    definitionIds: [{ id: 96506, specId: 265 }],
  },
  MASTER_RITUALIST_TALENT: {
    id: 387165,
    name: 'Master Ritualist',
    icon: 'spell_warlock_focusshadow',
    maxRanks: 2,
    entryIds: [91475],
    definitionIds: [{ id: 96477, specId: 267 }],
  },
  MAYHEM_TALENT: {
    id: 387506,
    name: 'Mayhem',
    icon: 'spell_warlock_demonbolt',
    maxRanks: 1,
    entryIds: [91494],
    definitionIds: [{ id: 96496, specId: 267 }],
  },
  MORTAL_COIL_TALENT: {
    id: 6789,
    name: 'Mortal Coil',
    icon: 'ability_warlock_mortalcoil',
    maxRanks: 1,
    entryIds: [91457],
    definitionIds: [{ id: 96459, specId: 266 }],
    manaCost: 5000,
  },
  NERZHULS_VOLITION_TALENT: {
    id: 387526,
    name: "Ner'zhul's Volition",
    icon: 'achievement_dungeon_shadowmoonhideout',
    maxRanks: 2,
    entryIds: [91514],
    definitionIds: [{ id: 96516, specId: 266 }],
  },
  NETHER_PORTAL_TALENT: {
    id: 267217,
    name: 'Nether Portal',
    icon: 'inv_netherportal',
    maxRanks: 1,
    entryIds: [91515],
    definitionIds: [{ id: 96517, specId: 266 }],
    soulShardsCost: 1,
  },
  NIGHTFALL_TALENT: {
    id: 108558,
    name: 'Nightfall',
    icon: 'spell_shadow_twilight',
    maxRanks: 1,
    entryIds: [91568],
    definitionIds: [{ id: 96570, specId: 265 }],
  },
  NIGHTMARE_TALENT: {
    id: 386648,
    name: 'Nightmare',
    icon: 'spell_shadow_possession',
    maxRanks: 1,
    entryIds: [91422],
    definitionIds: [{ id: 96424, specId: 266 }],
  },
  PACT_OF_THE_IMP_MOTHER_TALENT: {
    id: 387541,
    name: 'Pact of the Imp Mother',
    icon: 'inv_archaeology_70_impgenerator',
    maxRanks: 2,
    entryIds: [91522],
    definitionIds: [{ id: 96524, specId: 266 }],
  },
  PANDEMIC_INVOCATION_TALENT: {
    id: 386759,
    name: 'Pandemic Invocation',
    icon: 'spell_shadow_unsummonbuilding',
    maxRanks: 1,
    entryIds: [91573],
    definitionIds: [{ id: 96575, specId: 265 }],
  },
  PANDEMONIUM_TALENT: {
    id: 387509,
    name: 'Pandemonium',
    icon: 'ability_ironmaidens_whirlofblood',
    maxRanks: 1,
    entryIds: [91498],
    definitionIds: [{ id: 96500, specId: 267 }],
  },
  PHANTOM_SINGULARITY_TALENT: {
    id: 205179,
    name: 'Phantom Singularity',
    icon: 'inv_enchant_voidsphere',
    maxRanks: 1,
    entryIds: [91557],
    definitionIds: [{ id: 96559, specId: 265 }],
    manaCost: 2500,
  },
  POWER_OVERWHELMING_TALENT: {
    id: 387279,
    name: 'Power Overwhelming',
    icon: 'ability_warlock_improvedsoulleech',
    maxRanks: 2,
    entryIds: [91478],
    definitionIds: [{ id: 96480, specId: 267 }],
  },
  POWER_SIPHON_TALENT: {
    id: 264130,
    name: 'Power Siphon',
    icon: 'ability_warlock_backdraft',
    maxRanks: 1,
    entryIds: [91521],
    definitionIds: [{ id: 96523, specId: 266 }],
  },
  PROFANE_BARGAIN_TALENT: {
    id: 389576,
    name: 'Profane Bargain',
    icon: 'ability_argus_deathfog',
    maxRanks: 2,
    entryIds: [91426],
    definitionIds: [{ id: 96428, specId: 266 }],
  },
  PYROGENICS_TALENT: {
    id: 387095,
    name: 'Pyrogenics',
    icon: 'inv_jewelry_ring_65',
    maxRanks: 1,
    entryIds: [91489],
    definitionIds: [{ id: 96491, specId: 267 }],
  },
  RAGING_DEMONFIRE_TALENT: {
    id: 387166,
    name: 'Raging Demonfire',
    icon: 'spell_fire_ragnaros_lavaboltgreen',
    maxRanks: 2,
    entryIds: [91585],
    definitionIds: [{ id: 96587, specId: 267 }],
  },
  RAIN_OF_CHAOS_TALENT: {
    id: 266086,
    name: 'Rain of Chaos',
    icon: 'spell_fire_felrainoffire',
    maxRanks: 1,
    entryIds: [91472],
    definitionIds: [{ id: 96474, specId: 267 }],
  },
  RAIN_OF_FIRE_TALENT: {
    id: 5740,
    name: 'Rain of Fire',
    icon: 'spell_shadow_rainoffire',
    maxRanks: 1,
    entryIds: [91592],
    definitionIds: [{ id: 96594, specId: 267 }],
    soulShardsCost: 3,
  },
  REIGN_OF_TYRANNY_TALENT: {
    id: 427684,
    name: 'Reign of Tyranny',
    icon: 'ability_bossdarkvindicator_auraofoppression',
    maxRanks: 1,
    entryIds: [91509],
    definitionIds: [{ id: 96511, specId: 266 }],
  },
  RESOLUTE_BARRIER_TALENT: {
    id: 389359,
    name: 'Resolute Barrier',
    icon: 'inv_shield_1h_demonweapon_c_01',
    maxRanks: 2,
    entryIds: [91421],
    definitionIds: [{ id: 96423, specId: 266 }],
  },
  REVERSE_ENTROPY_TALENT: {
    id: 205148,
    name: 'Reverse Entropy',
    icon: 'spell_fire_playingwithfiregreen',
    maxRanks: 1,
    entryIds: [91496],
    definitionIds: [{ id: 96498, specId: 267 }],
  },
  RITUAL_OF_RUIN_TALENT: {
    id: 387156,
    name: 'Ritual of Ruin',
    icon: 'spell_fire_twilightrainoffire',
    maxRanks: 1,
    entryIds: [91483],
    definitionIds: [{ id: 96485, specId: 267 }],
  },
  ROARING_BLAZE_TALENT: {
    id: 205184,
    name: 'Roaring Blaze',
    icon: 'ability_warlock_inferno',
    maxRanks: 1,
    entryIds: [91588],
    definitionIds: [{ id: 96590, specId: 267 }],
  },
  ROLLING_HAVOC_TALENT: {
    id: 387569,
    name: 'Rolling Havoc',
    icon: 'warlock_pvp_banehavoc',
    maxRanks: 2,
    entryIds: [91474],
    definitionIds: [{ id: 96476, specId: 267 }],
  },
  RUIN_TALENT: {
    id: 387103,
    name: 'Ruin',
    icon: 'spell_fire_fire',
    maxRanks: 2,
    entryIds: [91584],
    definitionIds: [{ id: 96586, specId: 267 }],
  },
  SACRIFICED_SOULS_TALENT: {
    id: 267214,
    name: 'Sacrificed Souls',
    icon: 'ability_creature_disease_05',
    maxRanks: 2,
    entryIds: [91511],
    definitionIds: [{ id: 96513, specId: 266 }],
  },
  SACROLASHS_DARK_STRIKE_TALENT: {
    id: 386986,
    name: "Sacrolash's Dark Strike",
    icon: 'spell_nzinsanity_fearofdeath',
    maxRanks: 2,
    entryIds: [91555],
    definitionIds: [{ id: 96557, specId: 265 }],
  },
  SARGEREI_TECHNIQUE_TALENT: {
    id: 405955,
    name: 'Sargerei Technique',
    icon: '70_inscription_glyph_demonhunter_major',
    maxRanks: 2,
    entryIds: [115462],
    definitionIds: [{ id: 120474, specId: 266 }],
  },
  SCALDING_FLAMES_TALENT: {
    id: 388832,
    name: 'Scalding Flames',
    icon: 'spell_burningsoul',
    maxRanks: 2,
    entryIds: [91486],
    definitionIds: [{ id: 96488, specId: 267 }],
  },
  SEED_OF_CORRUPTION_TALENT: {
    id: 27243,
    name: 'Seed of Corruption',
    icon: 'spell_shadow_seedofdestruction',
    maxRanks: 1,
    entryIds: [91571],
    definitionIds: [{ id: 96573, specId: 265 }],
    soulShardsCost: 1,
  },
  SEIZED_VITALITY_TALENT: {
    id: 387250,
    name: 'Seized Vitality',
    icon: 'spell_shadow_skull',
    maxRanks: 2,
    entryIds: [91507],
    definitionIds: [{ id: 96509, specId: 265 }],
  },
  SHADOWBURN_TALENT: {
    id: 17877,
    name: 'Shadowburn',
    icon: 'spell_shadow_scourgebuild',
    maxRanks: 1,
    entryIds: [91582],
    definitionIds: [{ id: 96584, specId: 267 }],
    soulShardsCost: 1,
  },
  SHADOWFLAME_TALENT: {
    id: 384069,
    name: 'Shadowflame',
    icon: 'ability_warlock_shadowflame',
    maxRanks: 1,
    entryIds: [91450],
    definitionIds: [{ id: 96452, specId: 266 }],
    manaCost: 7500,
  },
  SHADOWFURY_TALENT: {
    id: 30283,
    name: 'Shadowfury',
    icon: 'ability_warlock_shadowfurytga',
    maxRanks: 1,
    entryIds: [91452],
    definitionIds: [{ id: 96454, specId: 266 }],
    manaCost: 2500,
  },
  SHADOWS_BITE_TALENT: {
    id: 387322,
    name: "Shadow's Bite",
    icon: 'spell_shadow_painspike',
    maxRanks: 1,
    entryIds: [91518],
    definitionIds: [{ id: 96520, specId: 266 }],
  },
  SHADOW_EMBRACE_TALENT: {
    id: 32388,
    name: 'Shadow Embrace',
    icon: 'spell_shadow_shadowembrace',
    maxRanks: 2,
    entryIds: [91565],
    definitionIds: [{ id: 96567, specId: 265 }],
  },
  SHADOW_INVOCATION_TALENT: {
    id: 422054,
    name: 'Shadow Invocation',
    icon: 'ability_bossfelorcs_necromancer_purple',
    maxRanks: 1,
    entryIds: [117751],
    definitionIds: [{ id: 122763, specId: 266 }],
  },
  SIPHON_LIFE_TALENT: {
    id: 63106,
    name: 'Siphon Life',
    icon: 'spell_shadow_requiem',
    maxRanks: 1,
    entryIds: [91574],
    definitionIds: [{ id: 96576, specId: 265 }],
    manaCost: 2500,
  },
  SOCRETHARS_GUILE_TALENT: {
    id: 405936,
    name: "Socrethar's Guile",
    icon: 'spell_fire_soulburn',
    maxRanks: 2,
    entryIds: [115461],
    definitionIds: [{ id: 120473, specId: 266 }],
  },
  SOULBOUND_TYRANT_TALENT: {
    id: 334585,
    name: 'Soulbound Tyrant',
    icon: 'inv_summondemonictyrant',
    maxRanks: 2,
    entryIds: [91510],
    definitionIds: [{ id: 96512, specId: 266 }],
  },
  SOULBURN_TALENT: {
    id: 385899,
    name: 'Soulburn',
    icon: 'spell_warlock_soulburn',
    maxRanks: 1,
    entryIds: [91469],
    definitionIds: [{ id: 96471, specId: 266 }],
    soulShardsCost: 1,
  },
  SOUL_CONDUIT_TALENT: {
    id: 215941,
    name: 'Soul Conduit',
    icon: 'spell_shadow_soulleech_2',
    maxRanks: 2,
    entryIds: [91431],
    definitionIds: [{ id: 96433, specId: 266 }],
  },
  SOUL_EATERS_GLUTTONY_TALENT: {
    id: 389630,
    name: "Soul-Eater's Gluttony",
    icon: 'ability_bossgorefiend_gorefiendscorruption',
    maxRanks: 2,
    entryIds: [91428],
    definitionIds: [{ id: 96430, specId: 265 }],
  },
  SOUL_FIRE_TALENT: {
    id: 6353,
    name: 'Soul Fire',
    icon: 'spell_fire_firebolt',
    maxRanks: 1,
    entryIds: [91492],
    definitionIds: [{ id: 96494, specId: 267 }],
    manaCost: 5000,
  },
  SOUL_FLAME_TALENT: {
    id: 199471,
    name: 'Soul Flame',
    icon: 'ability_argus_soulburst',
    maxRanks: 2,
    entryIds: [91562],
    definitionIds: [{ id: 96564, specId: 265 }],
  },
  SOUL_LINK_TALENT: {
    id: 108415,
    name: 'Soul Link',
    icon: 'ability_warlock_soullink',
    maxRanks: 1,
    entryIds: [91433],
    definitionIds: [{ id: 96435, specId: 266 }],
  },
  SOUL_ROT_TALENT: {
    id: 386997,
    name: 'Soul Rot',
    icon: 'ability_ardenweald_warlock',
    maxRanks: 1,
    entryIds: [91578],
    definitionIds: [{ id: 96580, specId: 265 }],
  },
  SOUL_STRIKE_TALENT: {
    id: 428344,
    name: 'Soul Strike',
    icon: 'inv_polearm_2h_fellord_04',
    maxRanks: 1,
    entryIds: [91538],
    definitionIds: [{ id: 96540, specId: 266 }],
  },
  SOUL_SWAP_TALENT: {
    id: 386951,
    name: 'Soul Swap',
    icon: 'ability_warlock_soulswap',
    maxRanks: 1,
    entryIds: [91558],
    definitionIds: [{ id: 96560, specId: 265 }],
    soulShardsCost: 1,
  },
  SOW_THE_SEEDS_TALENT: {
    id: 196226,
    name: 'Sow the Seeds',
    icon: 'spell_shadow_seedofdestruction',
    maxRanks: 1,
    entryIds: [91560],
    definitionIds: [{ id: 96562, specId: 265 }],
  },
  SPITEFUL_RECONSTITUTION_TALENT: {
    id: 428394,
    name: 'Spiteful Reconstitution',
    icon: 'spell_shadow_impphaseshift',
    maxRanks: 1,
    entryIds: [91519],
    definitionIds: [{ id: 96521, specId: 266 }],
  },
  STOLEN_POWER_TALENT: {
    id: 387602,
    name: 'Stolen Power',
    icon: 'ability_bossfelmagnaron_waveempowered',
    maxRanks: 1,
    entryIds: [91525],
    definitionIds: [{ id: 96527, specId: 266 }],
  },
  STRENGTH_OF_WILL_TALENT: {
    id: 317138,
    name: 'Strength of Will',
    icon: 'spell_shadow_demonictactics',
    maxRanks: 1,
    entryIds: [91468],
    definitionIds: [{ id: 96470, specId: 266 }],
  },
  SUMMON_DARKGLARE_TALENT: {
    id: 205180,
    name: 'Summon Darkglare',
    icon: 'inv_beholderwarlock',
    maxRanks: 1,
    entryIds: [91554],
    definitionIds: [{ id: 96556, specId: 265 }],
    manaCost: 5000,
  },
  SUMMON_DEMONIC_TYRANT_TALENT: {
    id: 265187,
    name: 'Summon Demonic Tyrant',
    icon: 'inv_summondemonictyrant',
    maxRanks: 1,
    entryIds: [91550],
    definitionIds: [{ id: 96552, specId: 266 }],
    manaCost: 5000,
  },
  SUMMON_INFERNAL_TALENT: {
    id: 1122,
    name: 'Summon Infernal',
    icon: 'spell_shadow_summoninfernal',
    maxRanks: 1,
    entryIds: [91502],
    definitionIds: [{ id: 96504, specId: 267 }],
    manaCost: 5000,
  },
  SUMMON_SOULKEEPER_TALENT: {
    id: 386244,
    name: 'Summon Soulkeeper',
    icon: 'spell_fel_elementaldevastation',
    maxRanks: 1,
    entryIds: [91448],
    definitionIds: [{ id: 96429, specId: 266 }],
  },
  SUMMON_VILEFIEND_TALENT: {
    id: 264119,
    name: 'Summon Vilefiend',
    icon: 'inv_argusfelstalkermount',
    maxRanks: 1,
    entryIds: [91537],
    definitionIds: [{ id: 96539, specId: 266 }],
    soulShardsCost: 1,
  },
  SWEET_SOULS_TALENT: {
    id: 386620,
    name: 'Sweet Souls',
    icon: 'spell_shadow_soulleech',
    maxRanks: 1,
    entryIds: [91435],
    definitionIds: [{ id: 96437, specId: 266 }],
  },
  TEACHINGS_OF_THE_BLACK_HARVEST_TALENT: {
    id: 385881,
    name: 'Teachings of the Black Harvest',
    icon: 'inv_misc_codexofxerrath_nochains',
    maxRanks: 1,
    entryIds: [91447],
    definitionIds: [{ id: 96449, specId: 266 }],
  },
  TEACHINGS_OF_THE_SATYR_TALENT: {
    id: 387972,
    name: 'Teachings of the Satyr',
    icon: 'spell_shadow_carrionswarm',
    maxRanks: 1,
    entryIds: [91443],
    definitionIds: [{ id: 96445, specId: 266 }],
  },
  THE_EXPENDABLES_TALENT: {
    id: 387600,
    name: 'The Expendables',
    icon: 'ability_warlock_impoweredimp',
    maxRanks: 1,
    entryIds: [91512],
    definitionIds: [{ id: 96514, specId: 266 }],
  },
  THE_HOUNDMASTERS_STRATAGEM_TALENT: {
    id: 267170,
    name: "The Houndmaster's Stratagem",
    icon: 'spell_warlock_calldreadstalkers',
    maxRanks: 1,
    entryIds: [91533],
    definitionIds: [{ id: 96535, specId: 266 }],
  },
  TORMENTED_CRESCENDO_TALENT: {
    id: 387075,
    name: 'Tormented Crescendo',
    icon: 'spell_warlock_soulburn',
    maxRanks: 1,
    entryIds: [91551],
    definitionIds: [{ id: 96553, specId: 265 }],
  },
  UMBRAL_BLAZE_TALENT: {
    id: 405798,
    name: 'Umbral Blaze',
    icon: 'ability_warlock_everlastingaffliction',
    maxRanks: 2,
    entryIds: [91529],
    definitionIds: [{ id: 96531, specId: 266 }],
  },
  UNSTABLE_AFFLICTION_TALENT: {
    id: 316099,
    name: 'Unstable Affliction',
    icon: 'spell_shadow_unstableaffliction_3',
    maxRanks: 1,
    entryIds: [91569],
    definitionIds: [{ id: 96571, specId: 265 }],
    manaCost: 2500,
  },
  VILE_TAINT_TALENT: {
    id: 278350,
    name: 'Vile Taint',
    icon: 'sha_spell_shadow_shadesofdarkness_nightborne',
    maxRanks: 1,
    entryIds: [91556],
    definitionIds: [{ id: 96558, specId: 265 }],
    soulShardsCost: 1,
  },
  WITHERING_BOLT_TALENT: {
    id: 386976,
    name: 'Withering Bolt',
    icon: 'spell_shadow_shadowbolt',
    maxRanks: 2,
    entryIds: [91577],
    definitionIds: [{ id: 96579, specId: 265 }],
  },
  WRATHFUL_MINION_TALENT: {
    id: 386864,
    name: 'Wrathful Minion',
    icon: 'spell_fel_incinerate',
    maxRanks: 1,
    entryIds: [91456],
    definitionIds: [{ id: 96458, specId: 266 }],
  },
  WRATH_OF_CONSUMPTION_TALENT: {
    id: 387065,
    name: 'Wrath of Consumption',
    icon: 'spell_nature_drowsy',
    maxRanks: 1,
    entryIds: [91553],
    definitionIds: [{ id: 96555, specId: 265 }],
  },
  WRITHE_IN_AGONY_TALENT: {
    id: 196102,
    name: 'Writhe in Agony',
    icon: 'spell_shadow_curseofsargeras',
    maxRanks: 1,
    entryIds: [91572],
    definitionIds: [{ id: 96574, specId: 265 }],
  },
  XAVIUS_GAMBIT_TALENT: {
    id: 416615,
    name: "Xavius' Gambit",
    icon: 'ability_xavius_blackeningsoul',
    maxRanks: 2,
    entryIds: [91429],
    definitionIds: [{ id: 96431, specId: 265 }],
  },
} satisfies Record<string, Talent>;

export default talents;
export { talents as TALENTS_WARLOCK };
